export default __webpack_public_path__ + "static/media/lady-right.a3d6e4a5.jpg";